var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencyKzt = function SvgIconCurrencyKzt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 4.875a1 1 0 0 1 1-1h13.5a1 1 0 1 1 0 2H5.25a1 1 0 0 1-1-1M4.25 9.375a1 1 0 0 1 1-1h13.5a1 1 0 1 1 0 2H13v9.5a1 1 0 1 1-2 0v-9.5H5.25a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconCurrencyKzt;